import React, {useEffect, useRef, useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {useTable} from "react-table";
import "jspdf-autotable";
import {useForm} from "react-hook-form";
import ConsoleHelper from "../ConsoleHelper";
import Select from "react-select";
import {MonthData, OverRidesSelect, WeekData, YearData} from "./SelectData";
import axios from "axios";
import {validateAccountManagerExistsApi} from "../Api";

function AccountManagerSchedule(props) {
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [data, setData] = useState([{}, {}]);
    const [isEditable, setIsEditable] = useState(false);
    const [buttonText, setButtonText] = useState("Save");
    const [selectedOption, setSelectedOption] = useState("1");
    const [selectedSurchargeOption, setSelectedSurchargeOption] = useState("1");
    const [selectedInterchangeOption, setSelectedInterchageOption] = useState("1");
    const [bankName, setBankName] = useState();
    const [bankAddress, setBankAddress] = useState();
    const [paramBankName, setParamBankName] = useState();
    const [paramBankAddress, setParamBankAddress] = useState();
    const [paramBankCity, setParamBankCity] = useState();
    const [paramBankPostalCode, setParamBankPostalCode] = useState([]);
    const [paramBankPhone, setParamBankPhone] = useState();
    const [paramBankCountry, setParamBankCountry] = useState();
    const [paramBankRegion, setParamBankRegion] = useState();
    const [paramHolderName, setParamHolderName] = useState();
    const [paramHolderAddress, setParamHolderAddress] = useState();
    const [paramHolderCity, setParamHolderCity] = useState();
    const [paramHolderPostalCode, setParamHolderPostalCode] = useState([]);
    const [paramHolderPhone, setParamHolderPhone] = useState();
    const [paramHolderCountry, setParamHolderCountry] = useState();
    const [accountType, setAccountType] = useState();
    const [country, setCountry] = useState();
    const [countryData, setCountryData] = useState();
    const [consolidationType, setConsolidationType] = useState();
    const [approvalFlag, setApprovalFlag] = useState(0);
    const [currentStatus, setCurrentStatus] = useState();
    const [paramHolderRegion, setParamHolderRegion] = useState();
    const [paramInterchangeACHFileID, setParamInterchangeACHFileID] = useState("1");
    const [paramSettlementACHFileID, setParamSettlementACHFileID] = useState("1");
    const [paramSurchargeACHFileID, setParamSurchargeACHFileID] = useState("1");
    const [paramSurchargeScheduleType, setParamSurchargeScheduleType] = useState();
    const [paramSurchargeThresholdAmount, setParamSurchargeThresholdAmount] = useState();
    const [paramSurchargeScheduleDay, setParamSurchargeScheduleDay] = useState();
    const [paramSurchargeSchedulePayoutDay, setParamSurchargeSchedulePayoutDay] = useState();
    const [paramSettlementScheduleType, setParamSettlementScheduleType] = useState();
    const [paramSettlementThresholdAmount, setParamSettlementThresholdAmount] = useState();
    const [paramSettlementScheduleDay, setParamSettlementScheduleDay] = useState();
    const [paramSettlementSchedulePayoutDay, setParamSettlementSchedulePayoutDay] = useState();
    const [paramInterchangeScheduleType, setParamInterchangeScheduleType] = useState();
    const [paramInterchangeThresholdAmount, setParamInterchangeThresholdAmount] = useState();
    const [paramInterchangeScheduleDay, setParamInterchangeScheduleDay] = useState();
    const [paramInterchangeSchedulePayoutDay, setParamInterchangeSchedulePayoutDay] = useState();
    const [rtaNumber, setRtaNumber] = useState();
    const [resetUserForm, setResetUserForm] = useState(false);
    const [paramAccountID, setParamAccountID] = useState();
    const defaultSelectOption = { label: "Daily", value: "0" };

    const [settlementSelect, setSettlementSelect] = useState(defaultSelectOption);
    const [surchargeSelect, setSurchargeSelect] = useState(defaultSelectOption);
    const [InterchangeSelect, setInterchangeSelect] =
        useState(defaultSelectOption);
    const [settlementEndDay, setSettlementEndDay] = useState();
    const [settlementPayoutDay, setSettlementPayoutDay] = useState();
    const settlementThreshold = useRef();
    const [surchargeEndDay, setSurchargeEndDay] = useState();
    const [surchargePayoutDay, setSurchargePayoutDay] = useState();
    const surchargeThreshold = useRef();
    const [interChangeEndDay, setInterChangeEndDay] = useState();
    const [interChangePayoutDay, setInterChangePayoutDay] = useState();
    const interChangeThreshold = useRef();
    const history = useHistory();
    const location = useLocation();

    const {
        reset,
        formState: { errors }
    } = useForm();
    //  Internally, customStyles will deep merges your customStyles with the default styling.


    const handleOptionChange = async (e) => {
        setSelectedOption(e.target.value)
        setParamSettlementACHFileID(e.target.value)
    };
    const handleSurchargeOptionChange = async (e) => {
        setSelectedSurchargeOption(e.target.value);
        setParamSurchargeACHFileID(e.target.value);
    };
    const handleInstallmentOptionChange = async (e) => {
        setSelectedInterchageOption(e.target.value);
        setParamInterchangeACHFileID(e.target.value);
    };


    useEffect(() => {
        ConsoleHelper("history schedule",history.location.state?.from?.split("?")[1])
        //setRta and account number
        let rtaFromLoc = (history.location.state?.from?.split("?")[1].split("=")?.[1]?.split("&")?.[0])?.replace(/[^\w @]/g, '');
        let paramAccountIDLoc = history.location.state?.from?.split("?")[1].split("=")?.[2]?.replace(/[^\w @]/g, '');
        //setRta and account number
        setRtaNumber(rtaFromLoc);
        setParamAccountID(paramAccountIDLoc);
        console.log(rtaNumber," ---=-=SCHED-==-=- ",paramAccountID)
        history.push({
            pathname: "/accountManager/schedule",
            search: `rta=${rtaFromLoc}&AccountID=${paramAccountIDLoc}`,
        });

        return () => {

        };
    }, [resetUserForm]);


    useEffect(() => {
        const getAccountDetails = async () => {
            const searchVal = location?.search?.split("=");
            setButtonText("Save");
            let rtaFromLoc = (location?.search?.split("=")?.[1].split("&")?.[0])?.replace(/[^\w @]/g, '');
            let paramAccountIDLoc = (location?.search?.split("=")?.[2].split("&")?.[0]).replace(/[^\w @]/g, '');
            setRtaNumber(rtaFromLoc);
            setParamAccountID(paramAccountIDLoc);
            ConsoleHelper(rtaFromLoc,"<----rta for Bank  acountId---->",paramAccountIDLoc);
            ConsoleHelper(" GET USERS BY LIST WITH ID",rtaNumber)
            const getAccountPropertiesDetails = await axios.get(`${validateAccountManagerExistsApi}?paramRTA=${(location?.search?.split("=")?.[1].split("&")?.[0]).replace(/[^\w @]/g, '')}&paramUserID=${loggedUserStorage}`);
            ConsoleHelper(" is valid account manager  data ",getAccountPropertiesDetails?.data?.response[0]);

            if(getAccountPropertiesDetails?.data?.response.length >0 ){
                setButtonText("Edit");
                setIsEditable(false);
                let accountTypeLbl = getAccountPropertiesDetails?.data?.response[0]?.accountType === "SAV"? "Savings":"Checking"
                setAccountType({
                    label: accountTypeLbl,
                    value: getAccountPropertiesDetails?.data?.response[0]?.accountType,
                });
                setCountry({
                    label: getAccountPropertiesDetails?.data?.response[0]?.branchCountry,
                    value: getAccountPropertiesDetails?.data?.response[0]?.branchCountry,
                });
                setParamHolderRegion({
                    label: getAccountPropertiesDetails?.data?.response[0]?.holderRegion,
                    value: getAccountPropertiesDetails?.data?.response[0]?.holderRegion,
                });
                setApprovalFlag(getAccountPropertiesDetails?.data?.response[0]?.requireApproval);//

                let currentStatusLbl = getAccountPropertiesDetails?.data?.response[0]?.status === "AC"? "Active":
                    (getAccountPropertiesDetails?.data?.response[0]?.status === "CD"?"Closed":
                        (getAccountPropertiesDetails?.data?.response[0]?.status === "PK"?"Deleted":""));
                setCurrentStatus({
                    label: currentStatusLbl,
                    value: getAccountPropertiesDetails?.data?.response[0]?.status,
                });//
                setParamHolderName(getAccountPropertiesDetails?.data?.response[0]?.holderName);
                setParamHolderAddress(getAccountPropertiesDetails?.data?.response[0]?.holderAddress);
                setParamHolderCity(getAccountPropertiesDetails?.data?.response[0]?.holderCity);
                setParamHolderPostalCode(getAccountPropertiesDetails?.data?.response[0]?.holderPostalCode);
                setParamHolderPhone(getAccountPropertiesDetails?.data?.response[0]?.holderPhone);
                setConsolidationType([
                    { label: getAccountPropertiesDetails?.data?.response[0]?.consolidationTypeDesc, value: getAccountPropertiesDetails?.data?.response[0]?.consolidationType },
                ]);

                //settlement
                setSelectedOption(getAccountPropertiesDetails?.data?.response[0]?.settlementACHFileID)

                setSettlementEndDay({
                    label: getAccountPropertiesDetails?.data?.response[0]?.settlementScheduleDay,
                    value: getAccountPropertiesDetails?.data?.response[0]?.settlementScheduleDay,
                });
                setSettlementPayoutDay({
                    label: getAccountPropertiesDetails?.data?.response[0]?.settlementSchedulePayoutDay,
                    value: getAccountPropertiesDetails?.data?.response[0]?.settlementSchedulePayoutDay,
                });
                setSettlementSelect({
                    label: getAccountPropertiesDetails?.data?.response[0]?.settlementScheduleTypeDesc,
                    value: getAccountPropertiesDetails?.data?.response[0]?.settlementScheduleType,
                });
                data["settlementThreshold"] = getAccountPropertiesDetails?.data?.response[0]?.settlementThresholdAmount;

                //surcharge
                setSelectedSurchargeOption(getAccountPropertiesDetails?.data?.response[0]?.surchargeACHFileID);
                setSurchargeEndDay({
                    label: getAccountPropertiesDetails?.data?.response[0]?.surchargeScheduleDay,
                    value: getAccountPropertiesDetails?.data?.response[0]?.surchargeScheduleDay,
                });
                setSurchargePayoutDay({
                    label: getAccountPropertiesDetails?.data?.response[0]?.surchargeSchedulePayoutDay,
                    value: getAccountPropertiesDetails?.data?.response[0]?.surchargeSchedulePayoutDay,
                });
                setSurchargeSelect({
                    label: getAccountPropertiesDetails?.data?.response[0]?.surchargeScheduleTypeDesc,
                    value: getAccountPropertiesDetails?.data?.response[0]?.surchargeScheduleType,
                });
                data["surchargeThreshold"] = getAccountPropertiesDetails?.data?.response[0]?.surchargeThresholdAmount;

                //interchange
                setSelectedInterchageOption(getAccountPropertiesDetails?.data?.response[0]?.interchangeACHFileID);
                setInterChangeEndDay({
                    label: getAccountPropertiesDetails?.data?.response[0]?.interchangeScheduleDay,
                    value: getAccountPropertiesDetails?.data?.response[0]?.interchangeScheduleDay,
                });
                setInterChangePayoutDay({
                    label: getAccountPropertiesDetails?.data?.response[0]?.interchangeSchedulePayoutDay,
                    value: getAccountPropertiesDetails?.data?.response[0]?.interchangeSchedulePayoutDay,
                });
                setInterchangeSelect({
                    label: getAccountPropertiesDetails?.data?.response[0]?.interchangeScheduleTypeDesc,
                    value: getAccountPropertiesDetails?.data?.response[0]?.interchangeScheduleType,
                });
                data["interChangeThreshold"] = getAccountPropertiesDetails?.data?.response[0]?.interchangeThresholdAmount;
            }
        };

        setCountryData([
            { label: "Select Country", value: "NA" },
            { label: "United States", value: "USA" },
            { label: "Mexico", value: "MEX" },
            { label: "Canada", value: "CAN" },
            { label: "India", value: "IND" },
            { label: "United Kingdom", value: "UK" },
            { label: "Europe ", value: "EUR" },
        ]);


        if( (typeof location?.search?.split("=")?.[1] !== "undefined")){
            getAccountDetails();
        }
        return () => {
            setData([]);
            // setUserOptions([]);

        };
    }, [location]);

    const handleReset = async (e) => {
        console.log(" resetting form")
    };

    const handleSettlementSelectChange = (e) => {
        setSettlementEndDay();
        setSettlementPayoutDay();
        setSettlementSelect(e);
    };
    const handleInterChangeSelectChange = (e) => {
        setInterChangeEndDay();
        setInterChangePayoutDay();
        setInterchangeSelect(e);
    };
    const handleSurchargeSelectChange = (e) => {
        setSurchargeEndDay();
        setSurchargePayoutDay();
        setSurchargeSelect(e);
    };

    const handleGetReport = () => {
        ConsoleHelper("---- calling save function")
        try {
            const paramComment = '';
            const paramResponse= '-1';

            const data = {};
            if (settlementSelect?.value === "5") {
                data["settlementThreshold"] = settlementThreshold?.current;
            } else {
                if(settlementSelect?.value != "0" && (typeof settlementEndDay?.value== "undefined" || typeof settlementPayoutDay?.value== "undefined")){
                    alert(" Please select Settlement EndDay and PayoutDay");
                    return false;
                }
                data["settlementEndDay"] = settlementEndDay?.value;
                data["settlementPayoutDay"] = settlementPayoutDay?.value;
            }

            if (surchargeSelect?.value === "5") {
                data["surchargeThreshold"] = surchargeThreshold?.current;
            } else {
                if(surchargeSelect?.value != "0" && (typeof surchargeEndDay?.value== "undefined" || typeof surchargePayoutDay?.value== "undefined")){
                    alert(" Please select Surcharge EndDay and PayoutDay");
                    return false;
                }
                data["surchargeEndDay"] = surchargeEndDay?.value;
                data["surChargePayoutDay"] = surchargePayoutDay?.value;
            }

            if (InterchangeSelect?.value === "5") {
                data["interChangeThreshold"] = interChangeThreshold?.current;
            } else {
                if(InterchangeSelect?.value != "0" && (typeof interChangeEndDay?.value== "undefined" || typeof interChangePayoutDay?.value== "undefined")){
                    alert(" Please select Interchange EndDay and PayoutDay");
                    return false;
                }
                data["interChangeEndDay"] = interChangeEndDay?.value;
                data["interChangePayoutDay"] = interChangePayoutDay?.value;
            }
            //console.log(data);


            ConsoleHelper(" bankName ",bankName)
            ConsoleHelper(" bankAddress ",bankAddress)

            ConsoleHelper("settlement ach type",paramSettlementACHFileID);
            ConsoleHelper("paramSettlementType ",settlementSelect);
            ConsoleHelper("paramSettlementScheduleDay ",settlementEndDay);
            ConsoleHelper("paramSettlementSchedulePayoutDay ",settlementPayoutDay);
            ConsoleHelper("paramSettlementThresholdAmount ",settlementThreshold);

            ConsoleHelper("surcharge ach type",paramSurchargeACHFileID);
            ConsoleHelper("param surcharge type ",surchargeSelect);
            ConsoleHelper("paramSurchargeDay ",surchargeEndDay);
            ConsoleHelper("paramSurchargePayoutDay ",surchargePayoutDay);
            ConsoleHelper("paramSurchrageThresholdAmount ",surchargeThreshold);

            ConsoleHelper("interchange ach type",paramInterchangeACHFileID);
            ConsoleHelper("param interchange",InterchangeSelect);
            ConsoleHelper("paraminterchangeDay ",interChangeEndDay);
            ConsoleHelper("paraminterchangePayoutDay ",interChangePayoutDay);
            ConsoleHelper("paraminterchangeThresholdAmount ",interChangeThreshold);

            /*const result = await axios.get(`${getTerminalTxnHistory}?paramRTA=${rtaNumber}&parambankName=${bank}&paramSettSchedule=${selectedSettlementScheduleOrder.value}&paramSurchargeSchedule=${selectedSurchargeScheduleOrder.value}&paramIntSchedule=${selectedInterchangeScheduleOrder.value}
            &paramConsolidation=${selectedConsolidationOrder.value}&paramUserID=${selectedVisibleToUser?.value}&paramOwner=${selectedAccountOwner.value}`);
            console.log(" get result data ",result?.data?.response);
            setData(result?.data?.response);*/
        } catch (error) {

            ConsoleHelper(error)
        }
    };

    const FormSelect = (props) => {
        return (
            <div class="form-group form-inline">
                <label for="exampleInputEmail1">{props.label}</label>
                <div class="input-group ml-2">
                    {!props.input ? (
                        <Select
                            options={props.options}
                            onChange={props.onChange}
                            defaultValue={props.defaultValue}
                            value={props.value}
                            styles={{
                                container: (provided) => ({
                                    ...provided,
                                    flex: 1,
                                    width: "13vw",
                                }),
                            }}
                        />
                    ) : (
                        <input
                            defaultValue={props.defaultValue}
                            onChange={props.onChange}
                            value={props.value}
                        />
                    )}
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className="row">
                <div className="col-md-12">

                    <form>
                        {/* 2 */}
                        <div className="row mt-3">
                            <div className="col col-md-12">
              <span
                  class="d-block p-2 text-white mb-3"
                  style={{ background: "#002170" }}
              >
                Settlement Funds &emsp; ACH File: Inst. RT - Inst. Name
              </span>
                            </div>
                                <div>
                                        <input
                                            type="radio"
                                            checked={(selectedOption === '1' || selectedOption === 1)}
                                            value={"1"}
                                            className="form-control form-control-sm"
                                            style={{width:"50px"}}
                                            onChange={handleOptionChange}
                                        />
                                </div>
                                <div  className="col col-md-6">
                                    <label>273970116 - Meta Payment System 1</label>
                                </div>
                            <div>
                                <input
                                    type="radio"
                                    checked={selectedOption === '2' || selectedOption === 2}
                                    value={"2"}
                                    className="form-control form-control-sm"
                                    style={{width:"40px"}}
                                    onChange={handleOptionChange}
                                />
                            </div>
                            <div className="col col-md-3">
                                <label>273970116 - Meta Payment System 2</label>
                            </div>
                           <div className="col-md-12"><hr/>
                           </div>
                            <div className="col col-md-6">Schedule Type:</div>
                            <div className="col col-md-6">
                                <Select
                                    options={OverRidesSelect}
                                    value={settlementSelect}
                                    onChange={handleSettlementSelectChange}
                                />
                            </div>
                            {settlementSelect?.value === 1 && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={WeekData}
                                            defaultValue={settlementEndDay}
                                            onChange={(e) => {
                                                setSettlementEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={WeekData}
                                            defaultValue={settlementPayoutDay}
                                            onChange={(e) => {
                                                setSettlementPayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {settlementSelect?.value === 3 && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={MonthData}
                                            defaultValue={settlementEndDay}
                                            onChange={(e) => {
                                                setSettlementEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={MonthData}
                                            defaultValue={settlementPayoutDay}
                                            onChange={(e) => {
                                                setSettlementPayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {settlementSelect?.value === "yearly" && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={YearData}
                                            defaultValue={settlementEndDay}
                                            onChange={(e) => {
                                                setSettlementEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            defaultValue={settlementPayoutDay}
                                            options={YearData}
                                            onChange={(e) => {
                                                setSettlementPayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {settlementSelect?.value === 5 && (
                                <div className="col col-md-12">
                                    <FormSelect
                                        label="Threshold Amount:"
                                        input
                                        defaultValue={settlementThreshold.current}
                                        onChange={(e) =>
                                            (settlementThreshold.current = e.target.value)
                                        }
                                    />
                                </div>
                            )}
                        </div>
                        {/* 3 */}
                        <div className="row mt-3">
                            <div className="col col-md-12">
              <span
                  class="d-block p-2 text-white mb-3"
                  style={{ background: "#002170" }}
              >
                Surcharge Funds &emsp; ACH File: Inst. RT - Inst. Name
              </span>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    checked={selectedSurchargeOption === '1' || selectedSurchargeOption === 1}
                                    value={"1"}
                                    className="form-control form-control-sm"
                                    style={{width:"50px"}}
                                    onChange={handleSurchargeOptionChange}
                                />
                            </div>
                            <div  className="col col-md-6">
                                <label>273970116 - Meta Payment System 1</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    checked={selectedSurchargeOption === '2' || selectedSurchargeOption === 2}
                                    value={"2"}
                                    className="form-control form-control-sm"
                                    style={{width:"40px"}}
                                    onChange={handleSurchargeOptionChange}
                                />
                            </div>
                            <div className="col col-md-3">
                                <label>273970116 - Meta Payment System 2</label>
                            </div>
                            <div className="col-md-12"><hr/></div>

                            <div className="col col-md-6">Surcharge Type:</div>
                            <div className="col col-md-6">
                                <Select
                                    options={OverRidesSelect}
                                    value={surchargeSelect}
                                    onChange={handleSurchargeSelectChange}
                                />
                            </div>
                            {surchargeSelect?.value === 1 && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={WeekData}
                                            defaultValue={surchargeEndDay}
                                            onChange={(e) => {
                                                setSurchargeEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={WeekData}
                                            defaultValue={surchargePayoutDay}
                                            onChange={(e) => {
                                                setSurchargePayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {surchargeSelect?.value === 3 && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={MonthData}
                                            defaultValue={surchargeEndDay}
                                            onChange={(e) => {
                                                setSurchargeEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={MonthData}
                                            defaultValue={surchargePayoutDay}
                                            onChange={(e) => {
                                                setSurchargePayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {surchargeSelect?.value === "yearly" && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={YearData}
                                            defaultValue={surchargeEndDay}
                                            onChange={(e) => {
                                                setSurchargeEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={YearData}
                                            defaultValue={surchargePayoutDay}
                                            onChange={(e) => {
                                                setSurchargePayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {surchargeSelect?.value === 5 && (
                                <div className="col col-md-12">
                                    <FormSelect
                                        label="Threshold Amount:"
                                        input
                                        defaultValue={surchargeThreshold.current}
                                        onChange={(e) => {
                                            surchargeThreshold.current = e.target.value;
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        {/* 4 */}
                        <div className="row mt-3">
                            <div className="col col-md-12">
              <span
                  class="d-block p-2 text-white mb-3"
                  style={{ background: "#002170" }}
              >
                Interchange Funds &emsp; ACH File: Inst. RT - Inst. Name
              </span>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    checked={selectedInterchangeOption === '1' || selectedInterchangeOption === 1}
                                    value={"1"}
                                    className="form-control form-control-sm"
                                    style={{width:"50px"}}
                                    onChange={handleInstallmentOptionChange}
                                />
                            </div>
                            <div  className="col col-md-6">
                                <label>273970116 - Meta Payment System 1</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    checked={selectedInterchangeOption === '2' || selectedInterchangeOption === 2}
                                    value={"2"}
                                    className="form-control form-control-sm"
                                    style={{width:"40px"}}
                                    onChange={handleInstallmentOptionChange}
                                />
                            </div>
                            <div className="col col-md-3">
                                <label>273970116 - Meta Payment System 2</label>
                            </div>
                            <div className="col-md-12"><hr/></div>

                            <div className="col col-md-6">Interchange Type:</div>
                            <div className="col col-md-6">
                                <Select
                                    options={OverRidesSelect}
                                    value={InterchangeSelect}
                                    onChange={handleInterChangeSelectChange}
                                />
                            </div>
                            {InterchangeSelect?.value === 1 && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={WeekData}
                                            defaultValue={interChangeEndDay}
                                            onChange={(e) => {
                                                setInterChangeEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={WeekData}
                                            defaultValue={interChangePayoutDay}
                                            onChange={(e) => {
                                                setInterChangePayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {InterchangeSelect?.value === 3 && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={MonthData}
                                            defaultValue={interChangeEndDay}
                                            onChange={(e) => {
                                                setInterChangeEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={MonthData}
                                            defaultValue={interChangePayoutDay}
                                            onChange={(e) => {
                                                setInterChangePayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {InterchangeSelect?.value === "yearly" && (
                                <>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="End Day:"
                                            options={YearData}
                                            defaultValue={interChangeEndDay}
                                            onChange={(e) => {
                                                setInterChangeEndDay(e);
                                            }}
                                        />
                                    </div>
                                    <div className="col col-md-12">
                                        <FormSelect
                                            label="Payout Day:"
                                            options={YearData}
                                            defaultValue={interChangePayoutDay}
                                            onChange={(e) => {
                                                setInterChangePayoutDay(e);
                                            }}
                                        />
                                    </div>
                                </>
                            )}
                            {InterchangeSelect?.value === 5 && (
                                <div className="col col-md-12">
                                    <FormSelect
                                        label="Threshold Amount:"
                                        input
                                        defaultValue={interChangeThreshold.current}
                                        onChange={(e) => {
                                            interChangeThreshold.current = e.target.value;
                                        }}
                                    />
                                </div>
                            )}
                        </div>
                        {/*  */}


                        <div className="row d-flex justify-content-center mt-1 align-items-center">
        <span
            class="input-group-text"
            role="button"
            onClick={() => handleGetReport()}>Save</span>

                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AccountManagerSchedule;
